import BaseService from '@root/core/class/BaseService';

class deliveryService extends BaseService {
  public getDeliveryAll = (
    fromDt?: string,
    toDt?: string,
    state?: string,
    searchBy?: string,
    input?: string,
    sort?: boolean,
    market?: string,
    status?: string
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    return this.get(
      `/deliveries?page=1&limit=99999${
        Boolean(searchBy) ? '&filterBy=' + searchBy : '&filterBy='
      }${Boolean(market) ? '&market=' + market : '&market='}${
        Boolean(status) ? '&status=' + status : '&status='
      }${Boolean(state) ? '&searchBy=' + state : '&searchBy='}${
        Boolean(inputUse) ? '&search=' + inputUse : '&search='
      }${Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='}${
        Boolean(toDt) ? '&toDt=' + toDt : '&toDt='
      }${Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'}`
    );
  };
  public getDeliveryModal = (
    fromDt?: string,
    toDt?: string,
    market?: string,
    status?: string
  ) => {
    console.log(market, status, '====');
    return this.get(
      `/deliveries?page=1&limit=99999${
        Boolean(market) ? '&market=' + market : '&market='
      }${Boolean(status) ? '&status=' + status : '&status='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}`
    );
  };
  public getPagingDelivery = (
    page: number,
    fromDt?: string,
    toDt?: string,
    state?: string,
    searchBy?: string,
    input?: string,
    sort?: boolean,
    market?: string,
    status?: string
  ) => {
    let inputUse = !!input
      ? input.replaceAll('%', '%25').replaceAll('#', '%23')
      : '';
    return this.get(
      `/deliveries?page=${page}&limit=10${
        Boolean(searchBy) ? '&filterBy=' + searchBy : '&filterBy='
      }${Boolean(market) ? '&market=' + market : '&market='}${
        Boolean(status) ? '&status=' + status : '&status='
      }${Boolean(state) ? '&searchBy=' + state : '&searchBy='}${
        Boolean(inputUse) ? '&search=' + inputUse : '&search='
      }${Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='}${
        Boolean(toDt) ? '&toDt=' + toDt : '&toDt='
      }${Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'}`
    );
  };

  public postDownExcelDelivery = (
    fromDt?: string,
    toDt?: string,
    searchBy?: string,
    input?: string,
    sort?: boolean,
    market?: string,
    status?: string
  ) => {
    return this.post(
      `/deliveries/export?${
        Boolean(searchBy) ? '&searchBy=' + searchBy : '&searchBy='
      }${Boolean(market) ? '&market=' + market : '&market='}${
        Boolean(status) ? '&status=' + status : '&status='
      }${Boolean(input) ? '&search=' + input : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}${
        Boolean(sort) ? '&sortBy=updated_at:DESC' : '&sortBy=updated_at:ASC'
      }`,
      {},
      {
        responseType: 'blob'
      }
    );
  };
  public postDownExcelDeliveryId = (body: Record<string, any>) => {
    return this.post('/deliveries/export', body, {
      responseType: 'blob'
    });
  };
  public getDetailDelivery = (deliveryId: number) => {
    return this.get(`/deliveries/${deliveryId}`, {});
  };
  public putDeliHistory = (body: Record<string, any>, deliveryId: number) => {
    return this.put(`/deliveries/${deliveryId}`, body);
  };

  public updateDelivery = (deliveryId: number, body: Record<string, any>) => {
    return this.put(`/deliveries/update/${deliveryId}`, body);
  };

  public getTemplateCSV = () => {
    return this.get(
      '/deliveries/csv',
      {},
      {
        responseType: 'blob'
      }
    );
  };

  public createShippingCSV = (form: FormData) => {
    return this.post('/deliveries/csv', form);
  };

  public downloadInvoice = ({
    deliveryId,
    orderNumber,
    sellerId
  }: {
    deliveryId: number;
    orderNumber: string;
    sellerId: number;
  }) => {
    return this.get(
      `/deliveries/${deliveryId}/download-invoice?orderNumber=${orderNumber}&sellerId=${sellerId}`,
      {},
      {
        'Content-Type': 'application/pdf',
        responseType: 'blob'
      }
    );
  };

  public downloadMessInvoice = (data: any) => {
    return this.post(
      '/deliveries/download-invoices',
      { data: data },
      {
        'Content-Type': 'application/zip',
        'Content-Disposition': 'attachment; filename=invoices.zip',
        'Access-Control-Expose-Headers': 'Content-Disposition'
      }
    );
  };
}

export default new deliveryService('/api/v1/warehouse', true);
